var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHow1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "150px",
    height: "167px",
    viewBox: "0 -3.125 150 167",
    enableBackground: "new 0 -3.125 150 167",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FAF1EF",
    cx: 28.485,
    cy: 25.296,
    r: 28.421
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FAF1EF",
    cx: 121.579,
    cy: 146.811,
    r: 28.421
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E5A7A1",
    d: "M26.069,69.199c0,0-7.522,2.569-7.215,7.354c0.309,4.785,7.215,6.811,7.215,6.811V69.199z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5A7A1",
    d: "M26.069,83.363c0,0-11.53,8.125-10.914,12.762s7.016,6.17,10.914,5.096V83.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5A7A1",
    d: "M26.069,105.227c0,0-9.681,5.943-9.681,11.377c0,5.432,3.329,8.057,9.681,5.512V105.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5A7A1",
    d: "M28.722,121.381c0,0-10.502,7.395-9.876,12.35c0.626,4.954,8.294,7.707,14.14,2.18L28.722,121.381z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#72C8B7",
    d: "M93.134,140.539H34.517c-4.665,0-8.447-3.781-8.447-8.447V17.083c0-4.666,3.782-8.448,8.447-8.448 h58.617c4.665,0,8.447,3.782,8.447,8.448v115.009C101.581,136.758,97.799,140.539,93.134,140.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M81.068,133.73H46.582c-9.176,0-16.615-7.439-16.615-16.615V32.059c0-9.176,7.439-16.614,16.615-16.614 h34.486c9.177,0,16.614,7.438,16.614,16.614v85.056C97.683,126.291,90.245,133.73,81.068,133.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M71.045,12.807H49.237c-0.583,0-1.055-0.473-1.055-1.055l0,0c0-0.583,0.472-1.055,1.055-1.055h21.808 c0.583,0,1.056,0.472,1.056,1.055l0,0C72.101,12.334,71.628,12.807,71.045,12.807z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M76.896,12.807h-1.79c-0.583,0-1.055-0.473-1.055-1.055l0,0c0-0.583,0.472-1.055,1.055-1.055h1.79 c0.582,0,1.055,0.472,1.055,1.055l0,0C77.95,12.334,77.478,12.807,76.896,12.807z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M91.2,138.591H29.079c-3.82,0-6.93-3.154-6.93-7.031V13.244c0-3.877,3.109-7.032,6.93-7.032H91.2 c3.82,0,6.93,3.154,6.93,7.032V131.56C98.13,135.437,95.021,138.591,91.2,138.591z M29.079,6.687 c-3.562,0-6.462,2.941-6.462,6.557V131.56c0,3.615,2.899,6.557,6.462,6.557H91.2c3.562,0,6.461-2.941,6.461-6.557V13.244 c0-3.616-2.898-6.557-6.461-6.557H29.079z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M91.766,60.599c0,3.881-0.749,7.647-2.227,11.192c-1.428,3.424-3.471,6.498-6.073,9.139 c-2.602,2.641-5.632,4.714-9.006,6.162c-3.494,1.499-7.204,2.26-11.029,2.26s-7.536-0.761-11.029-2.26 c-3.374-1.448-6.404-3.521-9.007-6.162s-4.646-5.715-6.072-9.139c-1.478-3.545-2.227-7.311-2.227-11.192 s0.749-7.647,2.227-11.191c1.427-3.424,3.47-6.499,6.072-9.139s5.633-4.713,9.007-6.162c3.493-1.5,7.204-2.26,11.029-2.26 s7.535,0.76,11.029,2.26c3.374,1.448,6.404,3.521,9.006,6.162c2.603,2.641,4.646,5.715,6.073,9.139 C91.017,52.952,91.766,56.718,91.766,60.599z M35.274,60.599c0,15.753,12.631,28.571,28.156,28.571 s28.156-12.817,28.156-28.571s-12.631-28.57-28.156-28.57S35.274,44.846,35.274,60.599z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A850",
    d: "M35.769,43.666c0.603,0.305,1.297,0.646,2.062,1.013c0.702,0.339,1.465,0.7,2.272,1.079 c8.512,3.992,21.941,9.842,21.941,9.842L51.112,33.932l-1.144-2.265l-1.043-2.068C43.114,32.624,38.45,37.595,35.769,43.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A850",
    d: "M64.549,28.902c15.896,0,28.781,13.076,28.781,29.205c0,16.129-12.886,29.204-28.781,29.204 c-15.895,0-28.78-13.074-28.78-29.204c0-4.251,0.895-8.291,2.505-11.934c0.604,0.305,1.297,0.646,2.062,1.014 c-1.464,3.337-2.277,7.032-2.277,10.92c0,9.959,5.77,17.184,13.7,21.83c3.892,2.278,7.976,5.052,12.791,5.052 c7.462,0,13.064-4.145,17.88-9.182c4.625-4.84,8.611-10.425,8.611-17.7c0-9.013-4.956-15.33-11.664-20.207 c-4.342-3.156-9.078-6.674-14.827-6.674c-4.35,0-8.454,1.064-12.074,2.949l-1.044-2.068 C55.364,30.058,59.824,28.902,64.549,28.902z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M37.83,44.679c0.702,0.339,1.465,0.7,2.272,1.079c8.512,3.992,21.941,9.842,21.941,9.842L51.112,33.932 l-1.144-2.265C44.6,34.461,40.293,39.062,37.83,44.679z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M64.549,31.226c5.749,0,10.485,3.518,14.827,6.674c6.708,4.877,11.664,11.194,11.664,20.207 c0,7.274-3.986,12.86-8.611,17.7c-4.815,5.037-10.418,9.182-17.88,9.182c-4.815,0-8.899-2.773-12.791-5.052 c-7.931-4.646-13.7-11.871-13.7-21.83c0-3.888,0.813-7.583,2.277-10.92c0.703,0.338,1.466,0.7,2.272,1.078 c-1.313,3.009-2.042,6.339-2.042,9.842c0,13.441,10.737,24.336,23.983,24.336s23.984-10.896,23.984-24.336 S77.795,33.77,64.549,33.77c-3.938,0-7.653,0.963-10.932,2.669l-1.143-2.265C56.095,32.29,60.199,31.226,64.549,31.226z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A850",
    d: "M64.549,33.77c13.246,0,23.984,10.896,23.984,24.337S77.795,82.443,64.549,82.443 S40.565,71.548,40.565,58.107c0-3.503,0.729-6.833,2.042-9.842c8.513,3.992,21.941,9.842,21.941,9.842L53.617,36.439 C56.896,34.733,60.611,33.77,64.549,33.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A850",
    d: "M51.112,33.932L62.044,55.6c0,0-13.43-5.851-21.941-9.842C42.329,40.652,46.236,36.47,51.112,33.932z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M59.091,40.078l-0.276-0.226c0.029-0.038,0.747-0.923,2.572-1.651c1.664-0.664,4.614-1.317,9.22-0.657 l-0.05,0.356c-4.508-0.646-7.388-0.018-9.01,0.623C59.796,39.215,59.098,40.07,59.091,40.078z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M69.288,37.565c0,0-0.324,5.29-5.284,5.034C64.004,42.599,64.29,39.271,69.288,37.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M66.13,37.446c0,0-3.496-0.599-4.311-3.52C61.819,33.926,64.876,33.821,66.13,37.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M62.044,38.152c0,0,1.47,3.03-2.128,5.132C59.916,43.284,58.894,40.623,62.044,38.152z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M68.831,37.774l-0.005,0.081c-0.002,0.013-0.091,1.35-0.789,2.636 c-0.411,0.757-0.951,1.35-1.603,1.762c-0.814,0.515-1.807,0.746-2.949,0.687l-0.056-0.003l0.005-0.056 c0.003-0.035,0.08-0.858,0.776-1.903c0.641-0.96,1.948-2.292,4.544-3.178L68.831,37.774z M63.549,42.833 c2.004,0.086,3.481-0.718,4.393-2.393c0.589-1.083,0.738-2.204,0.77-2.511c-2.512,0.875-3.782,2.167-4.406,3.102 C63.724,41.902,63.579,42.63,63.549,42.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M65.44,38.221l-0.09-0.015c-0.009-0.001-0.894-0.157-1.866-0.67 c-0.899-0.475-2.062-1.361-2.487-2.889l-0.018-0.067l0.068-0.002c0.031-0.001,0.787-0.022,1.709,0.405 c0.85,0.394,1.999,1.26,2.653,3.151L65.44,38.221z M61.121,34.687c0.431,1.448,1.546,2.294,2.413,2.752 c0.776,0.41,1.495,0.588,1.742,0.641c-0.646-1.792-1.747-2.619-2.564-2.998C61.971,34.739,61.328,34.692,61.121,34.687z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M63.165,40.345c0,0.1-0.004,0.202-0.012,0.308c-0.076,0.943-0.562,2.299-2.44,3.396l-0.054,0.032 l-0.022-0.059c-0.011-0.028-0.26-0.69-0.121-1.667c0.128-0.899,0.624-2.24,2.267-3.528l0.052-0.041l0.028,0.06 C62.877,38.875,63.165,39.482,63.165,40.345z M60.716,43.922c1.418-0.845,2.223-1.976,2.33-3.272 c0.068-0.831-0.17-1.493-0.253-1.692c-1.569,1.252-2.048,2.545-2.171,3.414C60.511,43.154,60.659,43.738,60.716,43.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M70.59,38.098l-0.017,0.108c-6.753-1.065-10.911,2.177-11.363,2.55l-0.006,0.004l-0.067-0.085 l0.006-0.004C59.598,40.295,63.79,37.025,70.59,38.098z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M63.224,48.809c0,0-2.017,2.691,0.001,4.118c2.018,1.427,2.928-0.407,2.424-1.062 c-0.503-0.655-0.87-1.104-0.301-1.109s1.88,3.877,4.24,3.296c2.359-0.581,1.822-2.473,0.731-2.982 c-1.092-0.508-3.883-0.881-3.94-1.621s0.345-0.873,0.967-0.438c0.622,0.435,1.647-0.218,1.096-1.34 S64.058,45.868,63.224,48.809z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M62.052,71.814c0,0,3.324,0.228,3.389-2.267c0.063-2.495-1.946-2.256-2.208-1.47 s-0.43,1.345-0.747,0.865c-0.316-0.48,2.156-3.726,0.38-5.406s-3.038-0.183-2.856,1.021s1.411,3.774,0.834,4.23 c-0.577,0.456-0.907,0.188-0.892-0.579c0.015-0.767-1.086-1.276-1.706-0.191C57.626,69.103,59.172,72.726,62.052,71.814z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 75.657,
    cy: 44.766,
    rx: 4.608,
    ry: 4.676
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 72.289,
    cy: 44.648,
    rx: 0.473,
    ry: 1.069
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M73.298,46.941c-0.265,0.203-0.32,0.584-0.128,0.859c0.2,0.286,0.508,0.578,0.9,0.498 c0.553-0.112,0.411-0.929,0.312-1.313c-0.031-0.121-0.138-0.207-0.261-0.209c-0.237-0.005-0.622,0.012-0.815,0.159 C73.304,46.937,73.301,46.938,73.298,46.941z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 75.066,
    cy: 41.741,
    rx: 0.591,
    ry: 0.866
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M76.428,47.833c0.311-0.081,0.613,0.053,0.676,0.299c0.062,0.246-0.138,0.512-0.449,0.593 c-0.311,0.082-0.613-0.052-0.676-0.299C75.915,48.181,76.117,47.915,76.428,47.833z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2465 -0.9691 0.9691 -0.2465 49.8743 123.9935)",
    fill: "#FFFFFF",
    cx: 73.14,
    cy: 42.608,
    rx: 0.291,
    ry: 0.368
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2463 -0.9692 0.9692 -0.2463 50.8886 132.7188)",
    fill: "#FFFFFF",
    cx: 77.05,
    cy: 46.572,
    rx: 0.291,
    ry: 0.368
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9728 -0.2317 0.2317 -0.9728 144.7045 110.3011)",
    fill: "#FFFFFF",
    cx: 78.831,
    cy: 46.652,
    rx: 0.288,
    ry: 0.373
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M76.436,42.352c0.178-0.282,0.499-0.396,0.716-0.255c0.218,0.141,0.249,0.484,0.071,0.767 c-0.179,0.282-0.499,0.396-0.717,0.255C76.289,42.978,76.257,42.634,76.436,42.352z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 77.413,
    cy: 44.943,
    rx: 0.872,
    ry: 0.627
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M75.491,44.753c0.241,0.423,0.197,0.907-0.099,1.08c-0.295,0.173-0.73-0.03-0.971-0.453 c-0.241-0.423-0.197-0.907,0.099-1.08C74.816,44.127,75.251,44.33,75.491,44.753z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M78.263,42.422c-0.24,0.161-0.325,0.479-0.214,0.749c0.234,0.572,0.756,1.641,1.218,1.145 C79.801,43.742,79.007,41.926,78.263,42.422z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 69.611,
    cy: 60.942,
    rx: 4.608,
    ry: 4.676
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 66.243,
    cy: 60.824,
    rx: 0.472,
    ry: 1.069
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M67.252,63.117c-0.266,0.204-0.321,0.584-0.129,0.859c0.2,0.286,0.508,0.578,0.9,0.499 c0.553-0.112,0.411-0.93,0.312-1.313c-0.031-0.121-0.138-0.207-0.261-0.209c-0.237-0.005-0.622,0.012-0.815,0.158 C67.258,63.112,67.255,63.114,67.252,63.117z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 69.02,
    cy: 57.917,
    rx: 0.592,
    ry: 0.867
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M70.381,64.01c0.311-0.082,0.614,0.052,0.677,0.299s-0.139,0.512-0.45,0.594 c-0.311,0.082-0.613-0.052-0.676-0.299S70.07,64.091,70.381,64.01z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2465 -0.9691 0.9691 -0.2465 26.6598 138.2965)",
    fill: "#FFFFFF",
    cx: 67.093,
    cy: 58.784,
    rx: 0.291,
    ry: 0.368
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2465 -0.9691 0.9691 -0.2465 27.6921 147.0269)",
    fill: "#FFFFFF",
    cx: 71.003,
    cy: 62.748,
    rx: 0.291,
    ry: 0.368
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9726 -0.2325 0.2325 -0.9726 128.9623 140.858)",
    fill: "#FFFFFF",
    cx: 72.784,
    cy: 62.828,
    rx: 0.288,
    ry: 0.373
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M70.389,58.528c0.179-0.282,0.499-0.396,0.717-0.255c0.217,0.142,0.248,0.485,0.07,0.767 c-0.179,0.282-0.499,0.396-0.717,0.255C70.242,59.154,70.21,58.811,70.389,58.528z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 71.366,
    cy: 61.119,
    rx: 0.873,
    ry: 0.627
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M69.445,60.93c0.24,0.423,0.196,0.907-0.1,1.08c-0.295,0.173-0.73-0.03-0.971-0.453 c-0.241-0.423-0.196-0.906,0.099-1.08C68.77,60.303,69.204,60.506,69.445,60.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M72.217,58.599c-0.241,0.161-0.326,0.478-0.216,0.748c0.235,0.573,0.758,1.641,1.219,1.146 C73.754,59.918,72.961,58.102,72.217,58.599z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 50.967,
    cy: 46.323,
    rx: 3.504,
    ry: 3.555
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 48.406,
    cy: 46.233,
    rx: 0.359,
    ry: 0.813
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M49.174,47.976c-0.202,0.155-0.244,0.444-0.098,0.654c0.152,0.217,0.386,0.439,0.685,0.378 c0.42-0.085,0.312-0.707,0.237-0.999c-0.024-0.092-0.104-0.157-0.198-0.159c-0.181-0.004-0.473,0.009-0.62,0.121 C49.178,47.973,49.176,47.975,49.174,47.976z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 50.518,
    cy: 44.023,
    rx: 0.449,
    ry: 0.659
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.247 -0.969 0.969 -0.247 16.9155 111.1339)",
    fill: "#FFFFFF",
    cx: 51.639,
    cy: 48.994,
    rx: 0.35,
    ry: 0.443
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2449 -0.9696 0.9696 -0.2449 17.7429 103.1836)",
    fill: "#FFFFFF",
    cx: 49.053,
    cy: 44.682,
    rx: 0.221,
    ry: 0.279
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2449 -0.9696 0.9696 -0.2449 18.5215 109.8174)",
    fill: "#FFFFFF",
    cx: 52.026,
    cy: 47.696,
    rx: 0.221,
    ry: 0.279
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9727 -0.232 0.232 -0.9727 94.2225 106.5948)",
    fill: "#FFFFFF",
    cx: 53.38,
    cy: 47.756,
    rx: 0.219,
    ry: 0.283
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M51.559,44.488c0.136-0.215,0.379-0.301,0.545-0.194c0.165,0.107,0.188,0.368,0.054,0.583 c-0.136,0.214-0.38,0.301-0.545,0.194S51.423,44.702,51.559,44.488z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 52.302,
    cy: 46.458,
    rx: 0.663,
    ry: 0.477
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M50.841,46.313c0.184,0.322,0.149,0.689-0.075,0.821c-0.225,0.132-0.555-0.022-0.738-0.344 c-0.183-0.322-0.149-0.689,0.075-0.821C50.327,45.837,50.658,45.992,50.841,46.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52.948,44.541c-0.184,0.122-0.247,0.364-0.164,0.569c0.179,0.436,0.576,1.248,0.927,0.871 C54.117,45.544,53.514,44.164,52.948,44.541z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 52.149,
    cy: 64.283,
    rx: 4.608,
    ry: 4.676
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 48.781,
    cy: 64.165,
    rx: 0.473,
    ry: 1.069
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M49.79,66.458c-0.266,0.203-0.32,0.584-0.128,0.859c0.2,0.286,0.508,0.578,0.899,0.498 c0.554-0.112,0.412-0.929,0.313-1.313c-0.032-0.121-0.138-0.207-0.262-0.209c-0.236-0.005-0.622,0.012-0.814,0.158 C49.796,66.453,49.793,66.455,49.79,66.458z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 51.559,
    cy: 61.258,
    rx: 0.591,
    ry: 0.867
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.247 -0.969 0.969 -0.247 0.4372 135.9335)",
    fill: "#FFFFFF",
    cx: 53.033,
    cy: 67.797,
    rx: 0.461,
    ry: 0.582
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2465 -0.9691 0.9691 -0.2465 1.6561 125.5376)",
    fill: "#FFFFFF",
    cx: 49.631,
    cy: 62.125,
    rx: 0.291,
    ry: 0.368
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2481 -0.9687 0.9687 -0.2481 2.7999 134.351)",
    fill: "#FFFFFF",
    cx: 53.542,
    cy: 66.089,
    rx: 0.291,
    ry: 0.367
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9725 -0.2329 0.2329 -0.9725 93.7108 143.4028)",
    fill: "#FFFFFF",
    cx: 55.322,
    cy: 66.168,
    rx: 0.287,
    ry: 0.373
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52.928,61.869c0.178-0.282,0.498-0.396,0.716-0.255c0.217,0.141,0.249,0.485,0.07,0.767 c-0.178,0.282-0.498,0.396-0.716,0.255C52.78,62.495,52.749,62.151,52.928,61.869z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 53.905,
    cy: 64.459,
    rx: 0.872,
    ry: 0.627
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M51.983,64.271c0.241,0.423,0.197,0.907-0.099,1.08c-0.296,0.173-0.73-0.03-0.971-0.453 c-0.241-0.423-0.197-0.907,0.099-1.08C51.308,63.644,51.742,63.847,51.983,64.271z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M54.755,61.939c-0.241,0.161-0.325,0.479-0.215,0.749c0.235,0.573,0.757,1.641,1.219,1.145 C56.292,63.259,55.499,61.442,54.755,61.939z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M79.916,44.249c0,2.586-2.074,4.69-4.623,4.69c-2.548,0-4.622-2.104-4.622-4.69s2.074-4.69,4.622-4.69 C77.842,39.558,79.916,41.662,79.916,44.249z M70.778,44.249c0,2.526,2.025,4.581,4.515,4.581c2.49,0,4.516-2.055,4.516-4.581 c0-2.526-2.025-4.582-4.516-4.582C72.804,39.667,70.778,41.722,70.778,44.249z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M74.391,62.792c0,2.586-2.074,4.69-4.623,4.69s-4.622-2.104-4.622-4.69s2.073-4.69,4.622-4.69 S74.391,60.206,74.391,62.792z M65.253,62.792c0,2.526,2.025,4.582,4.515,4.582c2.49,0,4.516-2.055,4.516-4.582 c0-2.526-2.025-4.582-4.516-4.582C67.278,58.21,65.253,60.266,65.253,62.792z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M56.071,63.321c0,2.586-2.074,4.69-4.623,4.69s-4.622-2.104-4.622-4.69c0-2.586,2.073-4.69,4.622-4.69 S56.071,60.735,56.071,63.321z M46.934,63.321c0,2.526,2.025,4.582,4.515,4.582c2.49,0,4.515-2.055,4.515-4.582 c0-2.526-2.024-4.581-4.515-4.581C48.959,58.74,46.934,60.795,46.934,63.321z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M82.786,48.737c0,1.11-0.075,2.21-0.226,3.29c-0.212,1.516-0.572,2.996-1.07,4.398 c-0.849,2.391-1.82,3.749-1.83,3.762l-0.145-0.107c0.01-0.014,0.969-1.355,1.809-3.724c0.775-2.185,1.604-5.715,1.155-10.126 l0.178-0.019C82.743,47.055,82.786,47.899,82.786,48.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M81.324,56.356c0,0-2.553,3.279-5.884,2.062C75.44,58.418,76.912,55.345,81.324,56.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M81.975,54.878c0,0-0.272,4.256,2.181,5.309C84.155,60.187,85.572,57.423,81.975,54.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M82.29,52.583c0,0-1.405,1.536-3.04,0.616C79.25,53.199,80.697,51.449,82.29,52.583z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M82.561,52.026c0,0,0.396,2.742,2.467,2.576C85.027,54.602,85.653,52.438,82.561,52.026z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M82.604,49.09c0,0-0.583,1.737-2.541,0.97C80.062,50.06,81.215,48.777,82.604,49.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M82.786,48.737c0,0,0.165,1.883,2.293,2.104C85.079,50.841,85.397,49.066,82.786,48.737z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M81.572,57.922l-0.052,0.068c-0.007,0.008-0.657,0.835-1.707,1.5c-0.973,0.615-2.497,1.216-4.238,0.58 l-0.057-0.021l0.026-0.055c0.016-0.032,0.385-0.789,1.306-1.431c0.848-0.592,2.341-1.187,4.639-0.66L81.572,57.922z  M75.671,59.988c1.675,0.586,3.143,0.006,4.083-0.589c0.861-0.545,1.449-1.2,1.626-1.409c-2.208-0.483-3.645,0.089-4.464,0.66 C76.156,59.179,75.773,59.803,75.671,59.988z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M84.351,60.437c0,0.816-0.268,1.351-0.28,1.376l-0.023,0.044l-0.045-0.02 c-1.021-0.438-1.727-1.506-2.042-3.088c-0.237-1.189-0.173-2.263-0.172-2.274l0.006-0.096l0.078,0.055 c1.875,1.326,2.374,2.716,2.462,3.648C84.346,60.205,84.351,60.323,84.351,60.437z M83.996,61.716 c0.073-0.169,0.312-0.792,0.23-1.63c-0.086-0.894-0.563-2.223-2.336-3.505c-0.009,0.29-0.019,1.181,0.175,2.149 C82.278,59.793,82.785,61.167,83.996,61.716z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M82.238,54.175l-0.042,0.045c-0.015,0.016-0.365,0.395-0.923,0.665 c-0.519,0.251-1.318,0.448-2.183-0.039l-0.058-0.032l0.042-0.051c0.016-0.018,0.375-0.449,0.939-0.746 c0.525-0.277,1.328-0.48,2.173,0.121L82.238,54.175z M79.202,54.784c0.644,0.34,1.323,0.341,2.021,0.004 c0.43-0.207,0.739-0.488,0.85-0.597c-0.627-0.422-1.302-0.449-2.006-0.079C79.632,54.341,79.314,54.662,79.202,54.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M85.001,55.756c0,0.265-0.051,0.446-0.056,0.462l-0.01,0.036l-0.037,0.003 c-0.869,0.07-1.582-0.364-2.062-1.253c-0.358-0.666-0.459-1.34-0.463-1.368l-0.011-0.071l0.071,0.009 c1.11,0.147,1.875,0.535,2.271,1.152C84.942,55.094,85.001,55.472,85.001,55.756z M84.852,56.15 c0.034-0.155,0.14-0.783-0.236-1.367c-0.37-0.575-1.084-0.942-2.123-1.092c0.036,0.192,0.157,0.737,0.44,1.262 C83.39,55.799,84.034,56.202,84.852,56.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M82.54,50.65l-0.02,0.058c-0.01,0.029-0.248,0.721-0.929,1.044c-0.475,0.225-1.04,0.211-1.683-0.041 l-0.072-0.029l0.053-0.059c0.012-0.013,1.189-1.302,2.592-0.986L82.54,50.65z M80.025,51.638 c0.581,0.212,1.092,0.217,1.52,0.015c0.528-0.25,0.779-0.752,0.852-0.923C81.251,50.511,80.268,51.398,80.025,51.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M85.013,52.258c0,0.113-0.012,0.185-0.014,0.193L84.99,52.5l-0.05-0.005 c-1.121-0.116-1.698-0.695-1.984-1.16c-0.311-0.504-0.354-0.974-0.356-0.993l-0.006-0.067l0.066,0.008 c0.964,0.122,1.646,0.451,2.028,0.979C84.965,51.643,85.013,52.033,85.013,52.258z M84.899,52.381 c0.013-0.151,0.022-0.614-0.299-1.057c-0.355-0.489-0.989-0.8-1.885-0.924c0.024,0.146,0.104,0.508,0.334,0.881 C83.44,51.912,84.062,52.282,84.899,52.381z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M82.636,49.056c-0.073,3.242-0.475,6.469-1.193,9.592c-0.572,2.491-1.194,4.219-1.428,4.869 c-0.057,0.158-0.102,0.283-0.105,0.306c0.001-0.007,0-0.022-0.012-0.036l-0.04,0.035v0.056l-0.045-0.024 c-0.021-0.032-0.021-0.032,0.102-0.374c2.019-5.617,2.536-10.945,2.614-14.426L82.636,49.056z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M73.751,73.207c0,0,0.093,3.042,1.946,2.82c1.854-0.221,2.762-0.387,2.853-1.658 c0.091-1.273-1.044-0.443-1.268-1.162c-0.223-0.719,1.559-0.94,2.686-0.442c1.126,0.497,2.823-0.222,2.356-2.71 c-0.468-2.489-4.666,1.161-5.21,0.773c-0.545-0.387-0.359-1.695,0.611-1.649c0.97,0.045,0.588-2.056-1.156-2.056 S73.059,69.612,73.751,73.207z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M58.115,48.598c0.724,0.345,0.88,1.555,0.349,2.702s-1.549,1.798-2.272,1.453 c-0.724-0.345-0.88-1.555-0.349-2.702S57.392,48.253,58.115,48.598z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58.266,50.308c0,0.526-0.117,0.971-0.352,1.332c-0.446,0.688-1.15,0.804-1.181,0.809l-0.021-0.144 l0.011,0.072l-0.011-0.072c0.007-0.001,0.674-0.112,1.084-0.747c0.373-0.576,0.427-1.393,0.16-2.426l0.139-0.037 C58.209,49.537,58.266,49.942,58.266,50.308z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M51.552,37.781c-0.117,0.579-0.935,0.898-1.826,0.713c-0.892-0.185-1.52-0.805-1.402-1.383 c0.116-0.579,0.934-0.898,1.825-0.713S51.668,37.202,51.552,37.781z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M50.384,38.182c-0.366,0.09-0.697,0.082-0.989-0.024c-0.557-0.203-0.758-0.689-0.767-0.709l0.097-0.04 l-0.048,0.02l0.048-0.02c0.002,0.005,0.193,0.465,0.707,0.651c0.465,0.169,1.044,0.068,1.72-0.3l0.05,0.093 C50.912,38.009,50.64,38.12,50.384,38.182z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M71.629,73.201c-0.173,0.853-1.377,1.322-2.69,1.05s-2.238-1.185-2.066-2.038s1.376-1.323,2.689-1.051 C70.875,71.436,71.801,72.348,71.629,73.201z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M69.909,73.791c-0.541,0.133-1.028,0.121-1.459-0.036c-0.82-0.299-1.116-1.015-1.128-1.045l0.143-0.06 l-0.071,0.029l0.071-0.029c0.002,0.007,0.285,0.685,1.04,0.959c0.687,0.249,1.539,0.1,2.535-0.442l0.072,0.138 C70.687,73.537,70.285,73.699,69.909,73.791z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.0427 0.9991 -0.9991 -0.0427 152.371 -17.0868)",
    fill: "#06065C",
    cx: 84.372,
    cy: 64.456,
    rx: 1.933,
    ry: 1.219
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M83.625,65.108c-0.168-0.408-0.22-0.793-0.153-1.151c0.127-0.682,0.637-1.003,0.659-1.017l0.062,0.104 l-0.031-0.052l0.031,0.052c-0.005,0.003-0.487,0.309-0.604,0.937c-0.104,0.57,0.114,1.222,0.651,1.938l-0.096,0.074 C83.916,65.688,83.742,65.393,83.625,65.108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#06065C",
    cx: 74.21,
    cy: 52.936,
    rx: 1.447,
    ry: 2.295
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M75.155,52.692c0,0.982-0.606,1.904-0.636,1.947l-0.089-0.061c0.008-0.012,0.788-1.199,0.582-2.272 c-0.089-0.457-0.344-0.832-0.76-1.115l0.06-0.091c0.441,0.3,0.712,0.698,0.806,1.185 C75.144,52.421,75.155,52.558,75.155,52.692z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M54.958,56.492c0.485-0.646,1.684-0.546,2.678,0.223c0.993,0.768,1.406,1.914,0.921,2.56 c-0.484,0.646-1.683,0.546-2.677-0.223C54.887,58.284,54.474,57.138,54.958,56.492z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M57.141,56.973c0.77,0.595,1.125,1.643,1.142,1.693l-0.103,0.035 c-0.005-0.013-0.462-1.362-1.429-1.846c-0.411-0.206-0.86-0.227-1.334-0.063l-0.034-0.103 c0.501-0.174,0.979-0.151,1.417,0.068C56.921,56.818,57.034,56.891,57.141,56.973z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M48.388,72.791c-0.742,0.303-1.722-0.404-2.189-1.58s-0.245-2.375,0.497-2.678 c0.741-0.303,1.721,0.403,2.188,1.579C49.352,71.287,49.129,72.486,48.388,72.791z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M46.754,71.246c-0.362-0.91-0.14-1.996-0.129-2.047l0.105,0.023c-0.003,0.014-0.289,1.411,0.298,2.327 c0.251,0.391,0.626,0.642,1.115,0.746l-0.021,0.107c-0.52-0.111-0.917-0.379-1.184-0.794 C46.864,71.493,46.804,71.371,46.754,71.246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M69.25,77.514c-2.361,0.318-4.645,0.339-6.785,0.059c-1.714-0.223-3.341-0.639-4.837-1.232 c-2.548-1.014-3.85-2.217-3.862-2.229l0.081-0.089c0.013,0.012,1.302,1.202,3.832,2.207 c2.335,0.928,6.235,1.883,11.556,1.164L69.25,77.514z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M65.66,77.618c0,0-4.127-0.579-4.639-3.979C61.021,73.639,64.285,72.918,65.66,77.618z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M61.904,77.431c0,0-1.445,3.485-5.299,1.366C56.605,78.797,58.149,77.244,61.904,77.431z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M57.133,76.066c0,0-2.911-0.977-3.188-5.671C53.944,70.396,57.343,71.742,57.133,76.066z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M65.448,77.593l-0.087-0.008c-0.011-0.001-1.103-0.11-2.227-0.632 c-1.496-0.694-2.372-1.801-2.533-3.201l-0.008-0.067h0.067c0.037-0.001,0.938,0.003,1.982,0.474 c0.965,0.435,2.23,1.369,2.781,3.35L65.448,77.593z M60.729,73.809c0.178,1.34,1.003,2.36,2.455,3.034 c0.922,0.429,1.82,0.573,2.1,0.61c-0.55-1.873-1.76-2.764-2.686-3.183C61.738,73.882,60.959,73.818,60.729,73.809z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M62.028,77.385l-0.079,0.087c-0.007,0.008-0.692,0.757-1.77,1.26 c-0.997,0.466-2.545,0.812-4.252-0.184l-0.046-0.026l0.021-0.049c0.007-0.019,0.189-0.452,1.032-0.803 c0.763-0.318,2.245-0.627,4.978-0.3L62.028,77.385z M56.038,78.472c1.642,0.933,3.127,0.599,4.088,0.151 c0.841-0.393,1.438-0.937,1.649-1.146c-2.611-0.299-4.037-0.005-4.776,0.298C56.353,78.039,56.11,78.355,56.038,78.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M57.176,76.171l-0.077-0.054c-0.028-0.02-0.69-0.486-1.304-1.411c-0.566-0.853-1.189-2.269-0.94-4.17 l0.013-0.099l0.081,0.057c0.007,0.005,0.719,0.516,1.347,1.454c0.579,0.866,1.206,2.286,0.896,4.129L57.176,76.171z  M54.96,70.656c-0.208,1.809,0.389,3.158,0.932,3.979c0.48,0.725,1.004,1.172,1.197,1.324 c0.265-1.754-0.335-3.107-0.891-3.939C55.706,71.283,55.162,70.816,54.96,70.656z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M66.391,77.691c-1.36,0.363-3.718,0.084-7.006-0.832c-2.445-0.681-4.519-1.479-4.539-1.486 l0.043-0.113c0.082,0.031,8.271,3.17,11.472,2.314L66.391,77.691z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M41.733,45.557c0.864-1.352,1.844-2.534,2.911-3.513c0.854-0.784,1.766-1.44,2.711-1.951 c1.61-0.871,2.774-1.018,2.786-1.02l0.01,0.081c-0.012,0.001-1.164,0.148-2.763,1.013c-1.475,0.798-3.642,2.389-5.588,5.434 L41.733,45.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M43.237,43.666c0,0,2.076-1.87,3.996-0.659C47.233,43.007,46.179,44.996,43.237,43.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M44.958,41.818c0,0-1.113-2.253,1.614-3.315C46.572,38.502,46.679,39.969,44.958,41.818z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M47.706,39.956c0,0,1.749-1.072,4.213,0.819C51.919,40.775,49.774,41.938,47.706,39.956z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M43.342,43.568l0.041-0.041c0.006-0.005,0.533-0.52,1.28-0.871c0.995-0.468,1.927-0.438,2.695,0.085 l0.037,0.025l-0.029,0.035c-0.016,0.02-0.407,0.481-1.095,0.813c-0.636,0.308-1.65,0.553-2.877-0.022L43.342,43.568z  M47.275,42.783c-0.746-0.489-1.613-0.507-2.578-0.054c-0.614,0.289-1.076,0.688-1.215,0.815 c1.173,0.529,2.142,0.293,2.752-0.001C46.802,43.27,47.171,42.896,47.275,42.783z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M44.928,41.901l-0.01-0.079c-0.001-0.007-0.077-0.683,0.138-1.455c0.2-0.715,0.697-1.66,1.935-2.106 l0.032-0.012l0.017,0.031c0.006,0.012,0.143,0.293-0.047,0.878c-0.172,0.529-0.66,1.426-2.007,2.688L44.928,41.901z  M46.98,38.352c-1.177,0.439-1.654,1.347-1.847,2.035c-0.169,0.602-0.155,1.145-0.144,1.345 c1.281-1.212,1.753-2.073,1.922-2.583C47.06,38.701,47.008,38.439,46.98,38.352z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M47.636,39.933l0.061-0.017c0.021-0.005,0.542-0.144,1.269-0.059c0.671,0.079,1.647,0.372,2.489,1.324 l0.044,0.05l-0.063,0.017c-0.006,0.001-0.569,0.146-1.31,0.062c-0.684-0.078-1.663-0.371-2.449-1.328L47.636,39.933z  M51.349,41.184c-0.813-0.891-1.745-1.169-2.39-1.245c-0.57-0.067-1.021,0.008-1.18,0.042 c0.761,0.896,1.695,1.174,2.352,1.249C50.712,41.295,51.181,41.219,51.349,41.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M42.884,44.01c0.408-0.857,1.569-1.947,3.451-3.24c1.399-0.961,2.695-1.682,2.709-1.688l0.038,0.071 c-0.052,0.028-5.167,2.877-6.126,4.893L42.884,44.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M42.409,65.931c-0.138-2.166-0.017-4.241,0.36-6.17c0.302-1.543,0.767-2.997,1.383-4.32 c1.049-2.255,2.189-3.364,2.201-3.375l0.074,0.079c-0.012,0.011-1.141,1.11-2.182,3.349c-0.96,2.066-2.04,5.553-1.729,10.432 L42.409,65.931z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M42.535,62.661c0,0,0.762-3.715,3.794-3.973C46.329,58.688,46.767,61.698,42.535,62.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M42.929,59.26c0,0-2.988-1.526-0.884-4.899C42.045,54.361,43.322,55.859,42.929,59.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC2B3",
    d: "M44.423,55.006c0,0,1.039-2.586,5.199-2.553C49.622,52.453,48.228,55.459,44.423,55.006z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M42.57,62.471l0.013-0.079c0.002-0.01,0.164-0.996,0.692-1.985c0.704-1.317,1.733-2.046,2.979-2.107 l0.06-0.003l-0.004,0.061c-0.002,0.034-0.059,0.852-0.538,1.773c-0.442,0.851-1.344,1.944-3.125,2.324L42.57,62.471z  M46.198,58.412c-1.194,0.08-2.146,0.768-2.828,2.046c-0.434,0.812-0.617,1.62-0.666,1.872 c1.687-0.386,2.547-1.431,2.972-2.247C46.071,59.324,46.175,58.62,46.198,58.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M42.962,59.375l-0.072-0.077c-0.006-0.007-0.625-0.675-1.004-1.685 c-0.351-0.935-0.562-2.361,0.42-3.853l0.026-0.04l0.042,0.021c0.016,0.008,0.387,0.2,0.646,0.987 c0.234,0.712,0.418,2.079-0.038,4.542L42.962,59.375z M42.366,53.865c-0.923,1.436-0.719,2.806-0.382,3.706 c0.295,0.788,0.739,1.363,0.911,1.569c0.424-2.355,0.25-3.669,0.028-4.359C42.729,54.178,42.465,53.938,42.366,53.865z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M44.328,55.039l0.052-0.067c0.02-0.024,0.472-0.598,1.324-1.099c0.787-0.463,2.075-0.943,3.738-0.602 l0.087,0.018l-0.056,0.07c-0.005,0.006-0.499,0.622-1.365,1.136c-0.8,0.474-2.091,0.957-3.699,0.564L44.328,55.039z  M49.33,53.36c-1.584-0.298-2.812,0.162-3.567,0.605c-0.67,0.393-1.096,0.842-1.242,1.008c1.531,0.347,2.763-0.116,3.53-0.571 C48.731,54,49.177,53.534,49.33,53.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M42.427,63.321c-0.239-1.258,0.151-3.384,1.159-6.317c0.749-2.18,1.579-4.016,1.588-4.035l0.098,0.046 c-0.033,0.073-3.301,7.325-2.739,10.285L42.427,63.321z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M48.072,28.381c-5.574,2.049-8.786,5.854-10.499,8.686c-1.857,3.07-2.402,5.689-2.408,5.715 l-0.14-0.029c0.005-0.026,0.554-2.667,2.423-5.757c1.098-1.815,2.429-3.43,3.958-4.799c1.911-1.711,4.138-3.041,6.617-3.953 L48.072,28.381z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M46.031,27.528c-5.576,2.05-8.788,5.857-10.501,8.69c-1.856,3.07-2.399,5.685-2.404,5.71L32.985,41.9 c0.005-0.026,0.554-2.667,2.422-5.758c1.099-1.815,2.43-3.43,3.959-4.798c1.911-1.711,4.137-3.041,6.617-3.953L46.031,27.528z "
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#0D0067",
    d: "M91.907,22.764h-55.39c-0.881,0-1.598-0.727-1.598-1.621c0-0.894,0.717-1.622,1.598-1.622h55.39 c0.881,0,1.598,0.728,1.598,1.622C93.505,22.037,92.788,22.764,91.907,22.764z M36.518,19.878c-0.688,0-1.247,0.568-1.247,1.266 c0,0.697,0.56,1.265,1.247,1.265h55.39c0.688,0,1.247-0.568,1.247-1.265c0-0.698-0.559-1.266-1.247-1.266H36.518z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0D0067",
    d: "M81.321,125.76h-33.78c-2.79,0-5.061-2.271-5.061-5.061v-3.418c0-2.791,2.271-5.062,5.061-5.062h33.78 c2.791,0,5.062,2.271,5.062,5.062v3.418C86.383,123.489,84.112,125.76,81.321,125.76z M47.541,113.283 c-2.204,0-3.997,1.793-3.997,3.998v3.418c0,2.203,1.793,3.996,3.997,3.996h33.78c2.204,0,3.997-1.793,3.997-3.996v-3.418 c0-2.205-1.793-3.998-3.997-3.998H47.541z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M56.713,118.994c0,0.458-0.072,0.879-0.215,1.262c-0.144,0.383-0.345,0.712-0.606,0.988 c-0.261,0.275-0.574,0.49-0.939,0.643c-0.366,0.152-0.771,0.229-1.215,0.229s-0.847-0.076-1.211-0.229 c-0.365-0.152-0.678-0.367-0.938-0.643c-0.262-0.276-0.463-0.605-0.606-0.988c-0.143-0.383-0.215-0.804-0.215-1.262 c0-0.459,0.072-0.879,0.215-1.262c0.144-0.383,0.345-0.713,0.606-0.99c0.261-0.278,0.573-0.494,0.938-0.647 c0.364-0.153,0.768-0.23,1.211-0.23s0.849,0.077,1.215,0.23c0.365,0.153,0.679,0.369,0.939,0.647 c0.262,0.277,0.463,0.607,0.606,0.99C56.641,118.115,56.713,118.535,56.713,118.994z M55.875,118.994 c0-0.377-0.051-0.713-0.151-1.012s-0.244-0.553-0.43-0.758c-0.185-0.207-0.409-0.365-0.673-0.477s-0.558-0.166-0.884-0.166 c-0.322,0-0.615,0.055-0.879,0.166s-0.489,0.27-0.676,0.477c-0.187,0.205-0.33,0.459-0.431,0.758 c-0.102,0.299-0.151,0.635-0.151,1.012c0,0.375,0.05,0.712,0.151,1.01c0.101,0.297,0.244,0.549,0.431,0.756 c0.187,0.206,0.412,0.364,0.676,0.473c0.264,0.11,0.557,0.165,0.879,0.165c0.326,0,0.62-0.055,0.884-0.165 c0.264-0.108,0.488-0.267,0.673-0.473c0.186-0.207,0.329-0.459,0.43-0.756C55.824,119.706,55.875,119.369,55.875,118.994z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M58.724,119.498v2.553h-0.812v-6.118h1.704c0.382,0,0.711,0.039,0.989,0.117 c0.277,0.079,0.507,0.191,0.688,0.339c0.182,0.148,0.315,0.327,0.402,0.537c0.087,0.209,0.131,0.443,0.131,0.701 c0,0.217-0.034,0.419-0.102,0.607c-0.067,0.188-0.165,0.355-0.293,0.506c-0.127,0.148-0.283,0.276-0.467,0.382 s-0.392,0.185-0.625,0.239c0.102,0.06,0.191,0.146,0.27,0.26l1.759,2.43h-0.724c-0.148,0-0.258-0.059-0.328-0.176 l-1.565-2.186c-0.048-0.068-0.1-0.117-0.155-0.146c-0.057-0.031-0.141-0.045-0.253-0.045H58.724z M58.724,118.896h0.854 c0.238,0,0.447-0.028,0.629-0.087c0.181-0.059,0.332-0.142,0.454-0.248c0.122-0.107,0.214-0.234,0.275-0.383 c0.062-0.147,0.093-0.311,0.093-0.49c0-0.364-0.118-0.639-0.355-0.824s-0.59-0.277-1.059-0.277h-0.892V118.896z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M68.473,118.994c0,0.458-0.071,0.875-0.215,1.25c-0.143,0.377-0.345,0.697-0.605,0.966 c-0.262,0.267-0.574,0.474-0.938,0.621c-0.365,0.146-0.769,0.22-1.212,0.22h-2.255v-6.118h2.255 c0.443,0,0.847,0.073,1.212,0.22c0.364,0.146,0.677,0.354,0.938,0.623c0.261,0.27,0.463,0.592,0.605,0.967 C68.401,118.119,68.473,118.535,68.473,118.994z M64.067,116.604v4.777h1.435c0.322,0,0.616-0.055,0.88-0.162 c0.264-0.108,0.487-0.265,0.673-0.469c0.186-0.203,0.328-0.453,0.43-0.748c0.101-0.297,0.15-0.633,0.15-1.008 c0-0.377-0.05-0.712-0.15-1.008c-0.102-0.297-0.244-0.547-0.43-0.752s-0.409-0.361-0.673-0.469L64.067,116.604z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M73.299,115.933v0.675h-2.895v2.032h2.343v0.649h-2.343v2.087h2.895v0.675h-3.716v-6.118H73.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M75.369,119.498v2.553h-0.812v-6.118h1.704c0.382,0,0.711,0.039,0.989,0.117 c0.277,0.079,0.507,0.191,0.688,0.339c0.181,0.148,0.314,0.327,0.402,0.537c0.086,0.209,0.13,0.443,0.13,0.701 c0,0.217-0.033,0.419-0.101,0.607c-0.067,0.188-0.165,0.355-0.293,0.506c-0.128,0.148-0.283,0.276-0.467,0.382 s-0.392,0.185-0.625,0.239c0.101,0.06,0.19,0.146,0.27,0.26l1.759,2.43h-0.724c-0.149,0-0.258-0.059-0.328-0.176l-1.565-2.186 c-0.048-0.068-0.1-0.117-0.155-0.146c-0.057-0.031-0.141-0.045-0.253-0.045H75.369z M75.369,118.896h0.854 c0.238,0,0.448-0.028,0.63-0.087c0.181-0.059,0.332-0.142,0.454-0.248c0.122-0.107,0.214-0.234,0.275-0.383 c0.062-0.147,0.093-0.311,0.093-0.49c0-0.364-0.119-0.639-0.355-0.824c-0.237-0.186-0.59-0.277-1.059-0.277h-0.892V118.896z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 35.996,
    y: 92.461,
    fill: "#E6A850",
    width: 12.717,
    height: 4.008
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.996,
    y: 101.221,
    fill: "#E6A850",
    width: 12.717,
    height: 4.006
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M47.573,106.641H34.401v-4.463h13.172V106.641z M34.857,106.184h12.26v-3.551h-12.26V106.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M47.573,98.251H34.401v-4.463h13.172V98.251z M34.857,97.795h12.26v-3.551h-12.26V97.795z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 95.271,
    fill: "#06065C",
    width: 40.871,
    height: 1.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 102.37,
    fill: "#06065C",
    width: 40.871,
    height: 1.707
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E5A7A1",
    d: "M104.756,194.45c0,0-3.083-6.783-6.475-11.099c-3.392-4.316-12.642-8.942-16.958-13.875 c-4.317-4.934-21.446-28.937-21.446-28.937h21.306c5.536,0,10.276-4.041,11.068-9.52c1.335-9.225-0.942-20.442-2.911-21.974 c-2.774-2.159-9.866-6.783-17.575-9.25c-6.862-2.195-13.237-6.104-14.987-10.635c-0.216-0.557-0.362-1.123-0.429-1.697 c-0.616-5.242,3.392-6.475,12.333-5.242c8.942,1.232,16.033,1.541,18.19,1.541c2.159,0,27.441,17.885,31.757,21.582 c4.317,3.701,2.775,11.101,4.626,21.584c1.85,10.482,16.648,38.539,16.648,38.539C141.754,177.801,104.756,194.45,104.756,194.45 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M114.298,166.318c-3.189,0-7.051-1.405-10.704-3.985c-4.95-3.497-10.261-9.845-10.316-17.172 c-0.173-22.818-2.436-32.454-2.459-32.548l0.443-0.107c0.023,0.095,2.298,9.781,2.472,32.652 c0.054,7.154,5.266,13.37,10.124,16.803c4.705,3.323,9.733,4.658,13.123,3.486l0.148,0.431 C116.273,166.174,115.32,166.318,114.298,166.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M80.289,92.486l-0.452-0.061c0.707-5.274,6.67-8.716,6.924-8.859l0.225,0.396 C86.926,83.997,80.965,87.438,80.289,92.486z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M85.626,92.493c-0.691-4.124,2.594-8.018,2.733-8.181l0.347,0.296c-0.032,0.038-3.285,3.897-2.631,7.81 L85.626,92.493z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M109.796,114.34l-0.281-0.359c3.429-2.68,9.922-7.698,9.986-7.748l0.279,0.36 C119.715,106.643,113.224,111.66,109.796,114.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M115.896,115.864h-0.457c0-3.39,4.983-7.427,5.195-7.597l0.285,0.355 C120.869,108.664,115.896,112.693,115.896,115.864z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M56.622,89.394l-0.058-0.149c-0.226-0.582-0.374-1.172-0.442-1.754c-0.225-1.916,0.148-3.32,1.142-4.295 c1.719-1.684,5.249-2.053,11.449-1.199l0.101,0.015l0.057,0.084c0.931,1.37,1.131,2.591,0.595,3.628 c-1.607,3.111-9.405,3.602-12.683,3.668L56.622,89.394z M63.255,82.015c-2.799,0-4.642,0.497-5.672,1.507 c-0.886,0.868-1.216,2.149-1.008,3.916c0.058,0.494,0.178,0.996,0.358,1.493c2.67-0.063,10.621-0.503,12.127-3.417 c0.442-0.857,0.271-1.893-0.511-3.079C66.501,82.156,64.742,82.015,63.255,82.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M78.67,148.418l-0.29-0.352c4.411-3.642,12.854-14.369,12.938-14.477l0.358,0.281 C91.592,133.979,83.119,144.746,78.67,148.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M74.877,143.459c-2.397,0-4.942-0.088-7.186-0.355l0.054-0.453c6.645,0.791,15.984,0.008,16.078,0 l0.039,0.454C83.8,143.109,79.631,143.459,74.877,143.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M104.839,194.662l-0.166-0.424c16.273-6.365,24.926-13.864,29.319-19.034 c4.405-5.184,5.522-9.123,5.671-9.707c-0.578-1.162-7.696-15.499-11.732-24.417c-4.2-9.279-6.015-24.321-6.032-24.472 l0.453-0.054c0.018,0.15,1.823,15.122,5.994,24.338c4.186,9.244,11.687,24.324,11.763,24.475l0.034,0.072l-0.016,0.077 c-0.036,0.172-0.945,4.273-5.76,9.95C129.941,180.687,121.226,188.254,104.839,194.662z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E54750",
    cx: 118.662,
    cy: 71.521,
    r: 8.781
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M113.667,80.454c-5.052,0-9.161-4.109-9.161-9.161c0-5.051,4.109-9.16,9.161-9.16s9.16,4.109,9.16,9.16 C122.827,76.345,118.719,80.454,113.667,80.454z M113.667,62.892c-4.633,0-8.401,3.77-8.401,8.401 c0,4.633,3.769,8.402,8.401,8.402s8.401-3.77,8.401-8.402C122.068,66.661,118.3,62.892,113.667,62.892z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E54750",
    cx: 138.638,
    cy: 71.521,
    r: 5.39
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E54750",
    points: "0,54.547 5.368,67.699 14.022,56.465  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M6.824,65.548L1.167,51.687l14.777,2.022L6.824,65.548z M1.864,52.228l5.078,12.444l8.188-10.628 L1.864,52.228z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHow1);
export default __webpack_public_path__ + "static/media/how_1.ce2d23645e1c0c08131289656db19a7a.svg";
export { ForwardRef as ReactComponent };